import { formatMoney } from "../../toll/money";
import { observer } from "mobx-react-lite";
import userStore from "../../stores/userStore";
import moment from "moment";
import PageBox from "../../layout/PageBox";
import { MyColor } from "../../config/myStyle";
import { member_icon } from "../../imgs";
import { donationStore } from "../../stores";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import MyRecorDonationItem from "./MyRecorDonationItem";
import { useTranslation } from "react-i18next";

const MyRecorDonationAmount = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userData = userStore.userData;

  useEffect(() => { userStore.getUser(); }, []);
  useEffect(() => {
    if (!userStore.userData?.id) return;
    donationStore.getDonationList({ limit: 3000, userId: userStore.userData?.id, })
  }, [userStore.userData?.id])

  const donationList = donationStore.donationList

  return (
    <PageBox spinning={donationStore.donationListStatus.loading}>
      <div>
        <div className="flex flex-col items-coneter px-[25px]" style={{ color: MyColor.blue, fontWeight: 500, fontSize: 16 }}>
          {/* 用户信息 */}
          <div className="flex items-center bg-[white] px-[20px] mt-[15px] pt-[10px]" style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10, borderBottomWidth: 5, borderColor: MyColor.sub }}>
            <img className="h-[54px]" src={member_icon} />
            <div className="ml-[25px]">
              <div
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical"
                }}
              >
                {[userData?.englishGivenName, userData?.englishSurname].filter(Boolean).join(' ')}
              </div>
              <div
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical"
                }}
              >
                {t("my_record_donation_amount.account_no")}{userData?.memberNumber??userData?.id}
              </div>
            </div>
          </div>

          {/* total donated */}
          <div className="flex flex-col items-center justify-center font-[700] text-[20px] mt-[10px] mb-[10px]" style={{ color: MyColor.blue, lineHeight: 1.4 }}>
            <div>{t("my_record_donation_amount.total_donated")}</div>
            <div className="text-[14px]">{t("my_record_donation_amount.hkd")}</div>
            <div className="text-[34px]" style={{ lineHeight: 1.2 }}>{formatMoney(userData?.donatedAmount)}</div>
            {userData?.donatedAt && (
              <div className="text-[14px] font-[400]">
                {t("my_record_donation_amount.balance_as_at")} {moment(userData?.donatedAt).format("D MMM, YYYY")}
              </div>
            )}
          </div>
          <div className="h-[2px] bg-[rgba(0,0,0,0.4)] " />

          {/* campaign items */}
          <div className="flex-col flex space-y-[10px] mt-[20px]">
            {donationList.map((item, index) => (
              <MyRecorDonationItem
                key={item.id}
                donation={item}
              />
            ))}
          </div>
        </div>
      </div>
    </PageBox>
  );
})

export default MyRecorDonationAmount;
